import React, {useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import Moment from "moment";
import * as api from "../../apis/covering";
import useAntTable from "../../utils/useAntTable";
import CoveringDetail from "./detail";
import {Button, message, Space} from "antd";
import UploadModal from "../../components/UploadModal";
import {useRequest} from "ahooks";
import PictureColumn from "../quotation-progress/pictureColumn";


function Covering() {

    const {tableProps} = useAntTable(api.getCoverings, {})

    const [selected, setSelected] = useState<any>()
    const [importModalVisible, setImportModalVisible] = useState(false)

    async function update() {
        await api.updateCoveringFromPink()
        message.success("Submit successfully")
    }

    const {run: onImport, loading: onImporting} = useRequest(api.importCoverings, {
        manual: true,
        onSuccess: (response) => {
            window.location.reload()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: 'Code',
            dataIndex: 'code',
            search: true
        },
        {
            title: 'Name',
            dataIndex: 'name',
            search: true
        },
        {
            title: 'Category',
            dataIndex: 'category',
            search: true
        },
        {
            title: 'Leather Grade',
            dataIndex: 'leatherGrade',
            search: true
        },
        {
            title: 'Cover Photo',
            dataIndex: 'coverPhotoUrl',
            render: value => (<PictureColumn label={'View fabric image'}>{value}</PictureColumn>),
        },
        {
            title: 'Description',
            dataIndex: 'description',
        },
        {
            title: 'Technical Features',
            dataIndex: 'technicalFeatures',
        },
        {
            title: 'Care Instructions',
            dataIndex: 'careInstructions',
        },
        {
            title: 'Created Time',
            dataIndex: 'createTime',
            render: (value) => Moment(value).format('lll')
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            render: (_,record:any) => (<PictureColumn label={'View'}>{record.seriesPhotoUrl}</PictureColumn>),
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <Button type={'primary'} onClick={() => setImportModalVisible(true)}>Import</Button>
                    <Button type={'primary'} onClick={() => update()}>Update</Button>
                </Space>
            )}/>
            <CoveringDetail covering={selected}
                            visible={selected}
                            onCancel={() => setSelected(undefined)}
            />
            <UploadModal title={'Import Covering'}
                         template={'/template/covering.xlsx'}
                         confirmLoading={onImporting}
                         onUpload={onImport}
                         visible={importModalVisible}
                         onCancel={() => setImportModalVisible(false)}/>
        </PageHeaderLayout>
    )
}

export default Covering
